// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './ScoreTag.module.scss'

export const ScoreTag = ({ score, label, className }) => (
  <Box
    ariaLabel={score}
    ariaRole="presentation"
    className={cx(styles.chip, { [className]: Boolean(className) })}
    justify="space-between"
    align="center"
    tagName="span"
  >
    <div className={styles.label}>{label}</div>
    <div className={styles.score}>{isNaN(score) ? '-' : Math.round(score)}</div>
  </Box>
)
